"use client";

import { Typography } from "@kyan/ui";
import type React from "react";

import { MarketStatItem } from "#/components/MarketStatItem/MarketStatItem";
import { usePerpInstrumentName } from "#/hooks/usePerpInstrumentName";
import { useFundingRates } from "#/store/perps/page/fundingRates";

import { DateAndTime } from "./components/DateAndTime";
import { getMarketStatItems } from "./PerpsMarketStats.config";

export const PerpsMarketStats: React.FC = () => {
  const { perpInstrumentName } = usePerpInstrumentName();
  const { fundingRates } = useFundingRates();

  const items = getMarketStatItems(
    fundingRates[perpInstrumentName]?.current,
    fundingRates[perpInstrumentName]?.previous,
  );

  return (
    <div className="flex w-full items-center justify-between gap-5">
      <div className="flex flex-col gap-1">
        <Typography grotesk primary size={12}>
          Funding
        </Typography>
        <div className="flex gap-5">
          {items.map((item) => (
            <MarketStatItem {...item} key={item.config.label} />
          ))}
        </div>
      </div>
      <DateAndTime />
    </div>
  );
};
